<div class="main-layout">
    <div class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1 class="m-0 text-dark">Create New Supplier</h1>
                </div>
                <!-- /.col -->

                <!-- /.col -->
            </div>
            <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <div class="content">
        <div class="container-fluid">
            <form [formGroup]="supplierForm">
                <div class="row">
                    <div class="col-md-6">
                        <div class="input-group">
                            <div class="label">Name<span class="text-danger-required">*</span></div>
                            <input formControlName="name" type="text" class="form-control"
                                placeholder="Please enter your name" id="name" />
                        </div>
                        <div class="text-danger"
                            *ngIf="supplierForm.get('name').invalid && (supplierForm.get('name').dirty || supplierForm.get('name').touched)">
                            <div *ngIf="supplierForm.get('name').errors?.['required']">Name is required.</div>
                            <div *ngIf="supplierForm.get('name').errors?.onlyLetters">Only Characters and spaces are allowed.</div>

                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="input-group">
                            <div class="label">Country Code<span class="text-danger-required">*</span></div>
                            <input formControlName="countrycode" type="text" class="form-control"
                                placeholder="Please enter country code" id="countrycode" />
                        </div>
                        <div class="text-danger"
                            *ngIf="supplierForm.get('countrycode').invalid && (supplierForm.get('countrycode').dirty || supplierForm.get('countrycode').touched)">
                            <div *ngIf="supplierForm.get('countrycode').errors?.['required']">CountryCode required.
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="input-group">
                            <div class="label">Phone<span class="text-danger-required">*</span></div>
                            <input formControlName="phone" type="text" class="form-control"
                                placeholder="Please enter your phone" id="phone" />
                        </div>
                        <div class="text-danger"
                            *ngIf="supplierForm.get('phone').invalid && (supplierForm.get('phone').dirty || supplierForm.get('phone').touched)">
                            <div *ngIf="supplierForm.get('phone').errors?.['required']">Phone number is required.</div>
                            <div *ngIf="supplierForm.get('phone').errors?.['pattern']">Phone number must be 10 digits.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="input-group">
                            <div class="label">Email<span class="text-danger-required">*</span></div>
                            <input formControlName="email" type="email" class="form-control" id="email"
                                placeholder="Please enter your email" />
                        </div>
                        <div class="text-danger"
                            *ngIf="supplierForm.get('email').invalid && (supplierForm.get('email').dirty || supplierForm.get('email').touched)">
                            <div *ngIf="supplierForm.get('email').errors?.['required']">Email is required.</div>
                            <div *ngIf="supplierForm.get('email').errors?.['pattern']">Invalid email address.</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="input-group">
                            <div class="label">City<span class="text-danger-required">*</span></div>
                            <!-- <input formControlName="cityid" type="text" class="form-control"
                                placeholder="Please enter cityid" id="cityid" /> -->

                            <select formControlName="cityid" id="cityid" class="form-control">
                                <option value="" disabled selected>Select a city</option>
                                <option *ngFor="let city of cities" [value]="city.id">{{ city.name }}</option>
                            </select>
                        </div>

                        <div *ngIf="supplierForm.get('cityid').invalid && supplierForm.get('cityid').touched"
                            class="text-danger">
                            Please select a city.
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="input-group">
                            <div class="label">Birds<span class="text-danger-required">*</span></div>
                            <select formControlName="birdstypeid" id="birdstypeid" class="form-control">
                                <option value="" disabled selected>Select a Bird Type</option>
                                <option *ngFor="let bird of birdTypes" [value]="bird.id">{{ bird.name }}</option>
                            </select>
                        </div>
                        <div *ngIf="supplierForm.get('birdstypeid').invalid && supplierForm.get('birdstypeid').touched"
                            class="text-danger">
                            Please select a Bird Type.
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="input-group">
                            <div class="label">Breed<span class="text-danger-required">*</span></div>

                            <select formControlName="breedid" id="breedid" class="form-control">
                                <option value="" disabled selected>Select</option>
                                <option *ngFor="let breed of breeds" [value]="breed.id">{{ breed.name }}</option>
                            </select>
                        </div>
                        <div *ngIf="supplierForm.get('breedid').invalid && supplierForm.get('breedid').touched"
                            class="text-danger">
                            Please select a Breed.
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="input-group">
                            <div class="label">Code<span class="text-danger-required">*</span></div>
                            <input readonly formControlName="code" (click)="generateCode()" type="text" class="form-control"
                                placeholder="Please enter code" id="code" />
                        </div>
                        <div class="text-danger"
                            *ngIf="supplierForm.get('code').invalid && (supplierForm.get('code').dirty || supplierForm.get('code').touched)">
                            <div *ngIf="supplierForm.get('code').errors?.['required']">Code is required.</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- /.col -->
                    <div class="col-12 text-center mt-3">
                        <button type="button" class="btn btn-primary" [disabled]="isLoading$ | async"
                            (click)="addSupplier()">
                            <span *ngIf="!isAuthLoading">create</span>
                            <span *ngIf="isAuthLoading">Submitting...</span>
                        </button>
                        <img *ngIf="isLoading$ | async" src="assets/img/loader.gif" alt="Loading..."
                            class="loader-image mt-2">
                    </div>
                    <!-- /.col -->
                </div>
            </form>
        </div>
    </div>
</div>
